import Vue from 'vue'
import Router from 'vue-router'

// v1 views
const StandardIndexV1 = () =>
    import ('@/v1/pages/Index')

const StandardIndexV1Travel = () =>
    import ('@/v1-travel/pages/Index')

// v2 views
const StandardIndexV2 = () =>
    import ('@/v2/pages/StandardViews/Index')

const AggregatorIndex = () =>
    import ('@/v2/pages/AggregatorViews/Index')

const UnableToOfferV2 = () =>
    import ('@/v2/pages/StandardViews/UnableToOffer')

const ErrorOccuredV2 = () =>
    import ('@/v2/pages/StandardViews/ErrorOccured')

const ResultsV2 = () =>
    import ('@/v2/pages/Results')

Vue.use(Router)

const useV2Flow = (process.env.VUE_APP_USE_V2_FLOW == 'true')
let useV1TravelFlow = (process.env.VUE_APP_USE_V1_TRAVEL_FLOW == 'true')

let urlParams = new URLSearchParams(window.location.search)

if (window.location.pathname === process.env.VUE_APP_TRAVEL_URL_PATH) {
    useV1TravelFlow = true
}

// default landing page
let indexComponent = (useV2Flow) ? StandardIndexV2 : StandardIndexV1;

let isAggregatorFlow = false

if (urlParams.has(process.env.VUE_APP_AGGREGATOR_ID)) {
    isAggregatorFlow = true
}
//this is for the console.log below
const flowName = (isAggregatorFlow || useV2Flow) ? 'v2' : (useV1TravelFlow) ? 'v1-travel' : 'v1'; 

// eslint-disable-next-line no-console
console.log(
    `%c Flow %c ${flowName} `,
    'background:#5BD095; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
    'background:#f5f5f5; padding: 1px; color: #000;'
)

let aggregatorRoutes = [{
        path: '/',
        name: 'home',
        component: AggregatorIndex,
        meta: {
            title: 'QuickCheck'
        }
    },
    {
        path: '/unable-to-offer',
        name: 'unable-to-offer',
        component: UnableToOfferV2,
        meta: {
            title: 'Unable to Offer - QuickCheck'
        }
    },
    {
        path: '/results',
        name: 'results',
        component: ResultsV2,
        meta: {
            title: `Congratulations, you've been pre-approved! - QuickCheck`
        }
    },
    {
        path: '/error-occurred',
        name: 'error-occurred',
        component: ErrorOccuredV2,
        meta: {
            title: `An Error Occurred - QuickCheck`
        }
    },
]

let standardRoutes = [{
    path: '/',
    name: 'home',
    component: indexComponent,
    meta: {
        title: 'QuickCheck'
    }
}]

let standardRoutesTravel = [{
    path: '/',
    name: 'home',
    component: StandardIndexV1Travel,
    meta: {
        title: 'QuickCheck Travel'
    }
}]

export default new Router({
    routes: isAggregatorFlow ? aggregatorRoutes : (useV1TravelFlow) ? standardRoutesTravel : standardRoutes
})